import React from "react";
import { ChevronDown, UserPlus } from "lucide-react";
// import ChatIconButton from "./chat/ChatIconButton";

const selectClass =
  "appearance-none pl-3 pr-9 py-2 rounded-lg border border-gray-200 bg-white text-sm font-medium text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-400";

/**
 * @param {Object} props
 * @param {{ id: string, name: string, status?: string }[]} props.campaigns — selectable campaigns (e.g. active only)
 * @param {string} props.selectedCampaignId
 * @param {(id: string) => void} props.onCampaignChange
 * @param {() => void} props.onAddInfluencer
 * @param {() => void} props.onNewCampaign
 * @param {boolean} [props.campaignsLoading]
 */
function PipelineHeader({
  campaigns,
  selectedCampaignId,
  onCampaignChange,
  onAddInfluencer,
  onNewCampaign,
  // onOpenInbox,
  // inboxUnread = 0,
  campaignsLoading = false,
}) {
  return (
    <header className="flex flex-col bg-white gap-2  sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col bg-white gap-2 lg:gap-3 sm:flex-row sm:items-center sm:gap-4 min-w-0">
        <h1 className="lg:text-2xl text-xl font-bold text-gray-900 tracking-tight shrink-0">
          Pipeline
        </h1>
        <div className="relative w-full sm:max-w-[220px]">
  <select
    data-guide="campaign-select"
    className={`${selectClass} w-full pr-8 truncate`}
    value={selectedCampaignId || ""}
    onChange={(e) => onCampaignChange(e.target.value)}
    disabled={campaignsLoading}
  >
    <option value="">Choose campaign</option>
    {campaigns.map((c) => (
      <option key={c.id} value={c.id}>
        {c.name}
      </option>
    ))}
  </select>

  <ChevronDown
    className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
  />
</div>
      </div>
      <div className="flex flex-wrap items-center gap-2 shrink-0">
        <button
          type="button"
          onClick={onAddInfluencer}
          className="inline-flex items-center gap-1 lg:gap-2 px-3 py-1 lg:px-4 lg:py-2 rounded-lg border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <UserPlus className="md:w-4 md:h-4 w-3 h-3" />
          Add influencer
        </button>
        {/* <ChatIconButton unreadCount={inboxUnread} onClick={onOpenInbox} /> */}
        <button
          type="button"
          onClick={onNewCampaign}
          className="inline-flex items-center px-3 py-1 lg:px-4 lg:py-2 rounded-lg bg-orange-500 text-white text-sm font-semibold hover:bg-orange-600 transition-colors shadow-sm"
        >
          New campaign
        </button>
      </div>
    </header>
  );
}

export default PipelineHeader;
